const jsonString = document.getElementById("cartSteps")?.innerHTML;
const cartSteps = jsonString ? JSON.parse(jsonString) : [];
const samplesString = document.getElementById("cartSamples")?.innerHTML;
const cartSamples = samplesString ? JSON.parse(samplesString) : [];

const refresh = async () => {
  await fetch("/cart.js");

  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
    })
  );
};

const updateCart = async (updates) => {
  await fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      updates,
    }),
  });

  await refresh();
};

document.addEventListener("cart:updated", async function (event) {
  const { items, total_price } = event.detail.cart;

  if (total_price > 0 || !jsonString) {
    handleAddingLogic(total_price, items, cartSamples);
  } else if (total_price === 0 && items.length > 0) {
    handleCleaningLogic(items);
  }
});

async function handleAddingLogic(total_price, items, cartSamples) {
  const remove = (id) => Object.assign(updates, { [`${id}`]: 0 });
  const add = (id) => Object.assign(updates, { [`${id}`]: 1 });
  const samples = items.filter((item) => cartSamples.includes(item.id));

  console.log(samples);

  let samples_length = samples.length;
  let maxStepNumberSamples = 0;
  let updates = {};

  for (let i = 0; i < cartSteps.length; i++) {
    const step = cartSteps[i];

    const { price, gift, numberSamples } = step;

    if (total_price / 100 >= price && numberSamples > maxStepNumberSamples) {
      maxStepNumberSamples = numberSamples;
    }

    if (gift) {
      const hasGift = items.some((item) => item.id === gift);

      if (total_price / 100 >= price && !hasGift) {
        add(gift);
      } else if (total_price / 100 < price && hasGift) {
        remove(gift);
      }
    }
  }

  // * SAMPLES
  console.log(samples.length, maxStepNumberSamples);
  const samplesToRemove = () => {
    if (samples.length > maxStepNumberSamples) {
      console.log("remove samples");
      const samplesCopy = [...samples];
      const removedSamples = samplesCopy
        .splice(maxStepNumberSamples)
        .map((sample) => String(sample.id));
      return removedSamples;
    } else {
      return [];
    }
  };

  const stepSamplesToRemove = samplesToRemove();

  console.log(stepSamplesToRemove);

  if (stepSamplesToRemove.length) {
    stepSamplesToRemove.forEach((sample) => {
      Object.assign(updates, { [sample]: 0 });
      samples_length--;
    });
  }

  if (Object.keys(updates).length > 0) {
    await updateCart(updates);
  } else {
    await refresh();
  }
}

async function handleCleaningLogic(items) {
  let updates = {};

  items
    .map((item) => item.id)
    .forEach((id) => {
      updates[`${id}`] = 0;
    });

  await fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      updates,
    }),
  });

  await fetch("/cart.js");
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
    })
  );

  await refresh();

  window.addingSample = false;
}

// FILTERS SIDECART
function openNav() {
  document.getElementById("filtersSidebar").style.width = "500px";
}

function closeNav() {
  document.getElementById("filtersSidebar").style.width = "0";
}

// ADD CLASS IN SCROLL SIDE-MENU
let scrollpos = window.scrollY;
let header = document.getElementById("mobile-menu-drawer");

function add_class_on_scroll() {
  header.classList.add("side-menu-top-position");
}

function remove_class_on_scroll() {
  header.classList.remove("side-menu-top-position");
}

window.addEventListener("scroll", function () {
  //Here you forgot to update the value
  scrollpos = window.scrollY;

  if (scrollpos > 58) {
    add_class_on_scroll();
  } else {
    remove_class_on_scroll();
  }
});

// TEXT SIDECART
async function setNote(note) {
  await fetch("/cart/update.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      note: note,
    }),
  });
  // 39892626767939

  await refresh();
}

var NoteModal = class extends HTMLElement {
  constructor() {
    super();
    this.input = document.querySelector("input[name=open-note-modal]");
    this.textarea = this.querySelector("textarea");
    this.inputFrom = this.querySelector("#senderName");
    this.querySelector("#submitNoteModal").addEventListener(
      "click",
      this.submitNoteModal
    );
    this.querySelector("#closeNoteModal").addEventListener(
      "click",
      this.closeNoteModal
    );
    this.init();
  }

  init = () => {
    const [note, from] = (window.cartNote || "").split("\nDe la part de ");
    this.textarea.value = note || "";
    this.inputFrom.value = from || "";
  };

  submitNoteModal = async () => {
    window.cartNote =
      this.textarea.value +
      `${
        this.inputFrom.value.length
          ? `\nDe la part de ${this.inputFrom.value}`
          : ""
      }`;
    await updateCart({ 39892626767939: 1 });
    await setNote(window.cartNote);
    this.classList.remove("show-extra-text");
  };
  closeNoteModal = async () => {
    this.input.checked = false;
    this.input.dispatchEvent(new Event("change", { bubbles: true }));
  };
};
window.customElements.define("note-modal", NoteModal);

var NoteModalCheckbox = class extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.input.addEventListener("change", this.onToggle);
    this.init();
  }

  init = () => {
    this.input.checked = window.cartNote.length > 0;
  };

  onToggle = async (e) => {
    const modal = document.querySelector("note-modal");
    const textarea = modal.querySelector("textarea");
    if (e.target.checked) {
      modal.classList.add("show-extra-text");
      textarea.setAttribute("is", "cart-note");
      textarea.setAttribute("id", "cart[note]");
    } else {
      textarea.setAttribute("is", "");
      textarea.setAttribute("id", "");
      modal.classList.remove("show-extra-text");
      await updateCart({ 39892626767939: 0 });
      if (textarea.value.length > 0) {
        textarea.value = "";
        window.cartNote = "";
        await setNote("");
      }
    }
  };
};
window.customElements.define("note-modal-checkbox", NoteModalCheckbox);

/* ============================================================
   FILTER SECTION — sélecteurs + cascade dépendante (BAÏJA)
   Le choix du filtre 1 restreint le filtre 2 ; le filtre 1+2
   restreint le filtre 3. Les combinaisons valides viennent du
   fichier asset filter-combos.json (généré depuis le catalogue).
   ============================================================ */
const FS_norm = (s) => {
  s = (s == null ? "" : String(s)).toLowerCase().trim().replace(/\s+/g, " ");
  s = s.normalize("NFD").replace(/[̀-ͯ]/g, "");
  if (s === "bouquet parfume") s = "bouquet";
  if (s === "un coffret") s = "coffret";
  return s;
};

const FS_valueFromOption = (opt) => {
  const v = opt && opt.value ? opt.value : "";
  const i = v.indexOf("=");
  let raw = i >= 0 ? v.slice(i + 1) : v;
  raw = raw.replace(/\+/g, " ");
  try {
    raw = decodeURIComponent(raw);
  } catch (e) {}
  return raw;
};

const applyFilter = (argElement) => {
  const filter = document.querySelector(argElement);
  if (!filter) {
    return;
  }
  const container = filter.querySelector(".cont-option");
  const optionsContainer = filter.querySelector(".options");
  const select = filter.querySelector("select");
  const text = filter.querySelector(".text");
  const options = filter.querySelectorAll(".option");
  const selectOptions = select ? select.querySelectorAll("option") : [];

  if (!select || !text || options.length <= 0 || selectOptions.length <= 0) {
    return;
  }

  if (optionsContainer) {
    optionsContainer.addEventListener("mouseout", function () {
      container.classList.remove("active");
    });
  }

  options.forEach((i) => {
    i.addEventListener("click", () => {
      text.innerHTML = i.innerHTML;
      selectOptions.forEach((o) => {
        o.defaultSelected = false;
        if (i.innerHTML.trim() === o.dataset.option.trim()) {
          o.defaultSelected = true;
        }
      });
      container.classList.add("active");
    });
  });
};

const FS_initCascade = (containerEl, combos) => {
  const filters = Array.prototype.slice
    .call(containerEl.querySelectorAll('.filter-custom-selector[id^="filter-"]'))
    .sort((a, b) => +a.id.split("-")[1] - +b.id.split("-")[1]);
  if (filters.length < 2) return;

  const blocks = filters.map((f) => {
    const select = f.querySelector("select");
    const head = f.querySelector(".head .text") || f.querySelector(".text");
    const lis = Array.prototype.slice.call(f.querySelectorAll(".options .option"));
    const opts = Array.prototype.slice.call(select.querySelectorAll("option"));
    const items = lis.map((li, idx) => {
      const opt = opts[idx];
      const value = FS_valueFromOption(opt);
      return {
        li: li,
        opt: opt,
        value: value,
        nvalue: FS_norm(value),
        label: (opt && opt.dataset.option ? opt.dataset.option : li.textContent).trim(),
      };
    });
    return { el: f, select: select, head: head, items: items };
  });

  const chosenNorm = (b) => {
    let chosen = null;
    b.select.querySelectorAll("option").forEach((o) => {
      if (o.defaultSelected) chosen = o;
    });
    if (!chosen) chosen = b.select.options[b.select.selectedIndex] || b.select.options[0];
    return FS_norm(FS_valueFromOption(chosen));
  };

  const setChosen = (b, item) => {
    const opts = b.select.querySelectorAll("option");
    opts.forEach((o) => {
      o.defaultSelected = false;
    });
    item.opt.defaultSelected = true;
    b.select.selectedIndex = Array.prototype.indexOf.call(opts, item.opt);
    if (b.head) b.head.innerHTML = item.label;
  };

  const applyTo = (b, validSet) => {
    const restrict = validSet && validSet.size > 0;
    let firstVisible = null;
    b.items.forEach((it) => {
      const show = !restrict || validSet.has(it.nvalue);
      it.li.style.display = show ? "" : "none";
      if (show && !firstVisible) firstVisible = it;
    });
    // Filet de sécurité : un menu ne doit jamais être vide -> on réaffiche tout
    if (!firstVisible) {
      b.items.forEach((it) => {
        it.li.style.display = "";
      });
      firstVisible = b.items[0];
    }
    const cur = chosenNorm(b);
    const curVisible = b.items.some(
      (it) => it.nvalue === cur && it.li.style.display !== "none"
    );
    if (!curVisible && firstVisible) setChosen(b, firstVisible);
  };

  const apply = () => {
    const n1 = chosenNorm(blocks[0]);
    if (blocks[1]) {
      const valid2 = new Set();
      combos.forEach((c) => {
        if (FS_norm(c[0]) === n1 && c[1]) valid2.add(FS_norm(c[1]));
      });
      applyTo(blocks[1], valid2);
    }
    if (blocks[2]) {
      const n2 = blocks[1] ? chosenNorm(blocks[1]) : "";
      const valid3 = new Set();
      combos.forEach((c) => {
        if (FS_norm(c[0]) === n1 && (!n2 || FS_norm(c[1]) === n2) && c[2])
          valid3.add(FS_norm(c[2]));
      });
      applyTo(blocks[2], valid3);
    }
  };

  blocks.forEach((b) => {
    b.items.forEach((it) => {
      it.li.addEventListener("click", () => {
        setChosen(b, it);
        apply();
      });
    });
  });

  apply();
};

window.addEventListener("load", (event) => {
  const btns = document.querySelectorAll(".btn-fs");

  btns.forEach((btn) => {
    btn.addEventListener("click", () => {
      let url = document.location.origin + "/collections/all-products/?";
      const container = document.querySelector(`.${btn.dataset.id}`);
      const selects = container.querySelectorAll("select");

      selects.forEach((select) => {
        url += `${select.value}&`;
      });

      window.location.href = url;
    });
  });

  document
    .querySelectorAll(`.filter-custom-selector[id*="filter"]`)
    .forEach((item) => {
      applyFilter(`#${item.id}`);
    });

  document.querySelectorAll("[data-combos]").forEach((containerEl) => {
    const url = containerEl.getAttribute("data-combos");
    if (!url) return;
    fetch(url)
      .then((r) => r.json())
      .then((combos) => {
        FS_initCascade(containerEl, combos);
      })
      .catch(() => {});
  });
});
